import i18n from 'modules/core/lib/i18n'

export type AdditionalSignerStrategy = 'manual_selection' | 'manager'

export const addtionalSignersSelectionTypes = () => [
  {
    label: i18n.t('processes.process_settings.tasks.form.manual_selection'),
    value: 'manual_selection',
  },
  {
    label: i18n.t('processes.process_settings.tasks.form.manager'),
    value: 'manager',
  },
]
